import styles from "./styles.module.scss";

export const LicenseInfoTag = ({ data }) => {
  return (
    <div className={styles.container}>
      <div className={styles.label}>{data.label}</div>
      <div className={styles.key}>{data.key}</div>
    </div>
  );
};
